export function postcode(value) {
  // var result = false;
  // var regex = /^[0-9]{4}$/;
  // result = regex.test(value);
  // return result;
  return true;
}

export function phone(val) {
  return true;

}

export function phoneAu(val) {
  return true;
}